import React from "react";
import { useLightbox, Lightbox as NewLightbox } from "../../package/lightbox";

const useImageLightBox = () => {
  const {
    isOpen,
    image,
    scale,
    rotation,
    position,
    showControls,
    setPosition,
    openLightbox,
    closeLightbox,
    zoomIn,
    zoomOut,
    resetZoom,
    rotateClockwise,
    rotateCounterClockwise,
    toggleControls,
    panImage,
  } = useLightbox();

  // Keep backward compatibility with the old API
  const setData = (data) => {
    if (!data) {
      closeLightbox();
    } else {
      const imageSrc = data.src ? data.src : data;
      openLightbox(imageSrc);

      // Apply the scaling effect that was previously in useEffect
      setTimeout(() => {
        zoomIn(); // Simulate the 1.5 scale from the original code
        zoomIn();
      }, 100);
    }
  };

  const Imagebox = () => {
    return (
      <div>
        {isOpen && (
          <NewLightbox
            image={image}
            isOpen={isOpen}
            onClose={closeLightbox}
            scale={scale}
            rotation={rotation}
            position={position}
            showControls={showControls}
            setPosition={setPosition}
            onZoomIn={zoomIn}
            onZoomOut={zoomOut}
            onResetZoom={resetZoom}
            onRotateClockwise={rotateClockwise}
            onRotateCounterClockwise={rotateCounterClockwise}
            onToggleControls={toggleControls}
            panImage={panImage}
          />
        )}
      </div>
    );
  };

  return { Imagebox, setData };
};

export default useImageLightBox;
